export const FETCH_LEADS_EXPORTS_START = 'FETCH_LEADS_EXPORTS_START'
export const FETCH_LEADS_EXPORTS_SUCCESS = 'FETCH_LEADS_EXPORTS_SUCCESS'
export const FETCH_LEADS_EXPORTS_FAILURE = 'FETCH_LEADS_EXPORTS_FAILURE'

export const CREATE_LEADS_EXPORT_START = 'CREATE_LEADS_EXPORT_START'
export const CREATE_LEADS_EXPORT_SUCCESS = 'CREATE_LEADS_EXPORT_SUCCESS'
export const CREATE_LEADS_EXPORT_FAILURE = 'CREATE_LEADS_EXPORT_FAILURE'
export const RESET_LEADS_EXPORT_CREATE = 'RESET_LEADS_EXPORT_CREATE'

export const LEADS_EXPORT_UPDATED = 'LEADS_EXPORT_UPDATED'
